module.exports = __webpack_public_path__ + "01_short_gold.4a7199c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/01_short_gold.png
// module id = AblM
// module chunks = 0